import * as React from 'react';
import { IMoeV2960ContainerViewProps } from './moe-v2-960-container';

export default (props: IMoeV2960ContainerViewProps) => {
    const moeContainerContentSlot =
        props.slots && props.slots.moeContainerContent && props.slots.moeContainerContent.length > 0
            ? props.slots.moeContainerContent
            : null;

    return (
        <div className='moe-v2-960-container'>
            {moeContainerContentSlot && moeContainerContentSlot.map((item, idx) => rendermoeContainerSlot(item, idx))}
        </div>
    );

    function rendermoeContainerSlot(moeContainerContent: React.ReactNode, index: number): JSX.Element | undefined {
        if (moeContainerContent === null) {
            return undefined;
        }
        return React.cloneElement(moeContainerContent as React.ReactElement, { key: `moe-v2-960-container__item-${index}` });
    }
};
